<template>
  <div class="register">
    <BackHome title="注册账号" />
    <div class="content">
      <Steps :current="current"></Steps>

      <div class="steps-content">
        <div v-if="current == 0">
          <a-input
            placeholder="请输入您的姓名"
            v-model="params.name"
            :maxLength="10"
            class="input-common"
          />
          <a-select
            placeholder="请选择证件类型"
            @change="chooseCardType"
            class="input-common"
            style="width: 100%"
          >
            <a-select-option
              v-for="(item, index) in cardTypeList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-input
            placeholder="请输入您的证件号码"
            v-model="params.idcard"
            :maxLength="18"
            class="input-common"
          />
          <div class="address-tips">请选择现居住地</div>
          <div class="address">
            <a-select
              placeholder="请选择"
              @change="chooseProvince"
              class="input-common"
              style="width: 123px; margin-right: 20px"
            >
              <a-select-option
                v-for="(item, index) in provinceData"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select
              placeholder="请选择"
              :value="params.cityId"
              @change="chooseCity"
              class="input-common"
              style="width: 123px; margin-right: 20px"
            >
              <a-select-option
                v-for="(item, index) in cityData"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select
              placeholder="请选择"
              :value="params.countyId"
              @change="chooseCounty"
              class="input-common"
              style="width: 123px"
            >
              <a-select-option
                v-for="(item, index) in countyData"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="button" @click="next">下一步</div>
          <div class="bottom">
            <div class="left" @click="toAgree">注册有问题？点这里！</div>
            <div class="right">
              已有账号<span class="login" @click="gotoLogin">马上登录</span>
            </div>
          </div>
        </div>
        <div v-else-if="current == 1">
          <a-input
            placeholder="请输入手机号"
            v-model="params.phone"
            :maxLength="11"
            class="input-common"
          />
          <div class="code">
            <a-input
              placeholder="请输入图片验证码"
              :maxLength="4"
              v-model="params.captcha"
              class="input-code"
            />
            <img
              :src="imageCode"
              alt=""
              @click="getCaptchaCode"
              class="imageCode"
            />
          </div>
          <div class="code">
            <a-input
              placeholder="请输入验证码"
              :maxLength="4"
              v-model="params.code"
              class="input-code"
            />
            <div
              :class="{
                'send-code': true,
                'disabled-btn': timerCount,
              }"
              @click="sendCode"
            >
              {{ codeText }}
            </div>
          </div>
          <a-input-password
            placeholder="请输入密码"
            v-model="params.password"
            class="input-common"
            style="margin-bottom: 10px"
          />
          <div
            class="input-common"
            style="color: #333333; text-align: left; height: auto"
          >
            密码须由8-16位数字、字母或符号组成，不可为纯数字
          </div>
          <a-input-password
            placeholder="请再次输入密码"
            v-model="params.password2"
            class="input-common"
          />
          <div class="button" @click="register">注册</div>
          <div class="bottom">
            <div class="left" @click="toAgree">注册有问题？点这里！</div>
            <div class="right">
              已有账号<span class="login" @click="gotoLogin">马上登录</span>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="register-done">注册成功！</div>
          <div class="register-tips">
            您的账号为身份证号，密码为自设密码。<span
              class="login"
              @click="gotoLogin"
              >前去登录→</span
            >
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="visible" title="注册助手" :footer="null" width="620px">
      <div class="modal-tips">问：注册时提示证件号已被注册怎么办？</div>
      <div class="modal-tips modal-tips-bottom">
        答：首先确认好您是否已经注册过“志愿晋中”账号，如已注册请直接登录即可，如未注册，您的账号可能已经被您的组织等机构导入注册，可直接用您的证件号登录，默认登录密码为您的证件号后八位（如果身份证号带“X”
        ，账号和密码中“X”都需大写）。
      </div>

      <div class="modal-tips">问：验证码已达上限怎么办？</div>
      <div class="modal-tips modal-tips-bottom">
        答：验证码每小时最多可错误输入3
        次，如已达上限，请隔一小时后重新获取,如当日已达上限，请次日再次获取。
      </div>

      <div class="modal-tips">问：获取不到验证码怎么办？</div>
      <div class="modal-tips modal-tips-bottom">
        答：如您获取不到验证码，请您直接拨打志愿汇官方客服热线：400-0035-125。
      </div>

      <div class="modal-tips">问：密码忘记怎么办?</div>
      <div class="modal-tips modal-tips-bottom">
        答：先使用初始密码身份证号码后8位（账号密码X大写）进行登陆。如不行点击页面右下侧“忘记密码”按钮，如有绑定手机号码请选择“通过手机号找回密码”，如未绑定手机号码或手机号错误等，请选择“上传手持证件照找回密码”，审核结果以短信方式告知。注意：提示的审核时间24小时是最迟24小时内审核，通常在工作时间段1-4小时左右基本都会处理！上传手持证件照找回密码时请输入现在能正常使用的手机号码，审核通过后会默认绑定该手机号码，上传手持证件照找回密码需本人手持身份证，本人跟身份证同时出镜，请根据示例进行操作。
      </div>

      <div class="modal-tips">问：我的身份证号被别注册了怎么办？</div>
      <div class="modal-tips modal-tips-bottom">
        答：您好，您的身份证号不是被别人注册的，这个情况应该是您们当地的志愿者协会或当地的社区志愿者组织帮您导入注册的。试一下账号是身份证号码，密码是身份证号码后8位，账号是您的身份证号，要是身份证号带X的话，账号和密码的X都要大写。
      </div>

      <div class="modal-tips">问：验证码已达上限怎么办？</div>
      <div class="modal-tips modal-tips-bottom">
        答：验证码每小时最多可错误输入3
        次，如已达上限，请隔一小时后重新获取,如当日已达上限，请次日再次获取。
      </div>

      <div class="modal-tips">
        问：登录时提示“账号未开启手机号登录，请使用证件号登录”？
      </div>
      <div class="modal-tips">
        答：首先可以使用证件号登录，登录成功后在“我的”账号设置中，开启手机号登录功能。
      </div>
    </a-modal>
  </div>
</template>

<script>
import BackHome from "@/components/common/BackHome.vue";
import Steps from "@/views/components/Steps.vue";
import { isIdentityId, isTel, isPassword } from "@/utils/validate";
import { uuid } from "vue-uuid";

export default {
  components: {
    BackHome,
    Steps,
  },
  data() {
    return {
      current: 0,
      params: {
        name: "",
        idcardtype: null,
        idcard: "",
        provinceId: "",
        cityId: undefined,
        countyId: undefined,
        phone: "",
        password: "",
        deptid: "1476084112357207a08eba11e682992c56dcba85b9",

        uuid: "", // 随机生成，用于获取图形验证码并验证
        captcha: "",
        code: "",
        password2: "",
      },

      cardTypeList: [],
      provinceData: [],
      cityData: [],
      countyData: [],

      imageCode: "", // 图形验证码url
      imageCodeLoading: false, // 图形验证码获取ing

      flag: false,
      timerCount: 0,
      codeTimer: null,
      loading: false,
      visible: false,
    };
  },
  computed: {
    codeText() {
      return this.timerCount == 0 ? "获取验证码" : this.timerCount + "(S)";
    },
  },
  created() {
    // this.$EventBus.$emit('showMenu', false);
  },
  mounted() {
    // 获取身份类型、省市区信息
    this.getCardTypes();
    this.getAreas();
  },
  methods: {
    next() {
      if (!this.params.name) {
        this.$message.error("请输入姓名");
        return;
      }
      if (!this.params.idcardtype) {
        this.$message.error("请选择证件类型");
        return;
      }
      if (this.params.idcardtype == 1) {
        if (isIdentityId(this.params.idcard)) {
          this.$message.error("请输入有效的身份证号码");
          return;
        }
      } else {
        if (!this.params.idcard) {
          this.$message.error("请输入证件号码");
          return;
        }
      }
      if (
        !this.params.provinceId ||
        !this.params.cityId ||
        !this.params.countyId
      ) {
        this.$message.error("请选择现居住地省市区信息");
        return;
      }

      this.getCaptchaCode();
      this.current++;
    },
    // 获取手机验证码
    sendCode() {
      // 正在请求
      if (this.flag) return;
      // 倒计时未结束
      if (this.timerCount) return;
      // 判断手机号
      if (!isTel(this.params.phone)) {
        this.$message.error("请输入合法的手机号码");
        return;
      }
      if (!this.params.captcha || this.params.captcha.length != 4) {
        this.$message.error("请输入完整的图形验证码");
        return;
      }
      // 开始请求
      this.flag = true;
      this.$api.vmsapi
        .sendCode({
          tel: this.params.phone,
          type: "1",
          id: this.params.uuid,
          code: this.params.captcha,
        })
        .then(() => {
          this.$message.success("验证码发送成功");
          this.timerCount = 60;
          this.codeTimer = setInterval(() => {
            this.timerCount--;
            if (this.timerCount <= 0) {
              this.timerCount = 0;
              clearInterval(this.codeTimer);
            }
          }, 1000);
        })
        .finally(() => {
          this.flag = false;
        });
    },
    // 注册
    register() {
      if (this.loading) return;
      if (!isTel(this.params.phone)) {
        this.$message.error("请输入合法的手机号码");
        return;
      }
      if (!this.params.captcha || this.params.captcha.length != 4) {
        this.$message.error("请输入完整的图形验证码");
        return;
      }
      if (!this.params.code || this.params.code.length != 4) {
        this.$message.error("请输入完整的短信验证码");
        return;
      }
      if (!isPassword(this.params.password)) {
        this.$message.error("请输入符合规则的密码");
        return;
      }
      if (this.params.password !== this.params.password2) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      this.verfiyCode();
    },
    // 验证短信
    verfiyCode() {
      this.loading = true;
      this.$api.vmsapi
        .checkCode({
          tel: this.params.phone,
          type: "1",
          code: this.params.code,
        })
        .then(() => {
          this.registerRequest();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 注册请求
    registerRequest() {
      const params = {
        name: this.params.name,
        mphone: this.params.phone,
        regprovince: this.params.provinceId,
        regcity: this.params.cityId,
        regcounty: this.params.countyId,
        idcard: this.params.idcard,
        idcardtype: this.params.idcardtype,
        password: this.params.password,
        deptid: this.params.deptid,
      };
      this.$api.vmsapi
        .register(params)
        .then(() => {
          this.current = 2;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择证件类型
    chooseCardType(value) {
      this.params.idcardtype = value;
    },
    // 获取证件类型
    getCardTypes() {
      this.$api.vmsapi.getDict("idcardType").then((res) => {
        this.cardTypeList = res;
      });
    },
    chooseProvince(value) {
      this.params.provinceId = value;
      this.params.cityId = undefined;
      this.params.countyId = undefined;
      this.getAreas(1, value);
    },
    chooseCity(value) {
      this.params.cityId = value;
      this.params.countyId = undefined;
      this.getAreas(2, value);
    },
    chooseCounty(value) {
      this.params.countyId = value;
    },
    // 获取省市区
    getAreas(level = 0, id = "14737477846505d6208a5e781435b84e2e079304353cb") {
      this.$api.vmsapi.getArea(id).then((res) => {
        if (level === 0) {
          this.provinceData = res;
          this.params.cityId = undefined;
          this.params.countyId = undefined;
        } else if (level === 1) {
          this.cityData = res;
          this.params.countyId = undefined;
        } else {
          this.countyData = res;
        }
      });
    },
    // 获取图形验证码
    getCaptchaCode() {
      if (this.imageCodeLoading) return;
      this.imageCodeLoading = true;
      this.params.uuid = uuid.v1();
      this.$api.vmsapi
        .imageCode({ id: this.params.uuid })
        .then((res) => {
          this.imageCode = res.image;
        })
        .finally(() => {
          this.imageCodeLoading = false;
          this.params.captcha = "";
        });
    },

    toAgree() {
      this.visible = true;
    },
    gotoLogin() {
      this.$router.replace({ name: "login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  width: 770px;
  margin: 0 auto;
  margin-bottom: 100px;
  
  .content {
    background-color: #ffffff;
    padding: 50px 180px 80px;

    .steps-content {
      width: 100%;

      .button {
        height: 36px;
        background: #cd3232;
        border-radius: 2px;
        margin-bottom: 20px;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: Helvetica;
        color: #ffffff;
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #cd3232;
          cursor: pointer;
        }
        .right {
          font-size: 14px;
          font-family: Helvetica;
          color: #727384;
        }
      }
      .login {
        color: #cd3232;
        margin-left: 5px;
        cursor: pointer;
      }

      .input-common {
        margin-bottom: 20px;
        font-size: 14px;
        font-family: Helvetica;
        height: 36px;
      }

      .address-tips {
        font-size: 14px;
        font-family: Helvetica;
        color: #333333;
        text-align: left;
        margin-bottom: 20px;
      }

      .code {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        font-size: 14px;
        font-family: Helvetica;
      }
      .input-code {
        margin-right: 20px;
        flex: 1;
        height: 36px;
      }

      .imageCode {
        width: 100px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #bdbdbd;
        cursor: pointer;
      }
      .send-code {
        width: 100px;
        height: 36px;
        background: #cd3232;
        border-radius: 2px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
      }
      .disabled-btn {
        background-color: #ccc !important;
        cursor: not-allowed;
      }

      .register-done {
        font-size: 20px;
        font-family: Helvetica;
        color: #333333;
        margin: 30px auto 20px;
      }
      .register-tips {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
.modal-tips {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.modal-tips-bottom {
  margin-bottom: 20px;
}
</style>